{
    "commonUIText": {
        "buttonBack": "Go back",
        "prev": "Prev",
        "previous": "Previous",
        "next": "Next",
        "scrollDownToContinue": "Scroll down to continue",
        "close": "Close",
        "lifk": "Living Infrastructure Field Kit",
        "menu": "Menu",
        "settings": "Settings",
        "references": "References"
    },
    "testingText": {
        "test": "This is a Test",
        "Hello": "Hello",
        "Array": [
            "This is the first item",
            "This is the second item",
            "This is the third item"
        ]
    },
    "ReferencesSidebar": {
        "remedies": "Remedies",
        "benefits": "Benefits",
        "layers": "Layers",
        "search": "Search",
        "searchPlaceholder": "Search for an article...",
        "clearSearch": "Clear search",
        "missingSearchResults": "Don't see what you're looking for?",
        "tellUs": "Tell us what we are missing"
    },
    "UIRightPanel": {
        "dragHandleAriaLabel": "Drag to resize, drag down to close"
    },
    "UIModal": {
        "submit": "Submit",
        "cancel": "Cancel",
        "okay": "Okay",
        "discard": "Discard",
        "delete": "Delete",
        "clearProgress": "Clear Progress",
        "remove": "Remove"
    },
    "TutorialSampleLink": {
        "openSample": "View the Magic Johnson Park sample project"
    },
    "ChooseTutorialModal": {
        "title": "Guided tutorials",
        "subtitle": "Learn by doing. Guided tutorials are step-by-step walkthroughs that help you accomplish different goals in the Field Kit.",
        "savedNotice": "Anything you create through the tutorials will be saved. Feel free to build — you can manually delete any tutorial content when you’re finished.",
        "returningTitle": "Welcome to the refreshed Field Kit!",
        "close": "Close tutorials",
        "skipAndExplore": "Skip and start exploring",
        "understandingPlace": {
            "title": "Understand a place",
            "description": "Select a site to view detailed insights about its opportunities and conditions."
        },
        "exploreMap": {
            "title": "Explore the map",
            "description": "Turn on the Data Layers tool to reveal the conditions across the map."
        },
        "createProject": {
            "title": "Design a site",
            "description": "Select a site, add remedies, and evaluate their costs and benefits."
        },
        "engageCommunity": {
            "title": "Collect local knowledge",
            "description": "Drop a pin, share an idea or insight, and find it again in the comments panel."
        },
        "sampleSketch": {
            "title": "Tour the sample sketch",
            "description": "See how living infrastructure revived Magic Johnson Park, then sketch your own."
        }
    },
    "TutorialOverlay": {
        "regionLabel": "Guided tutorial",
        "skipTour": "Skip tour",
        "gotIt": "Got it",
        "startExploring": "Start exploring",
        "exploreMore": "Explore more tutorials",
        "stepAnnouncement": "{title} {actionHint} Step {step} of {count}.",
        "finaleAnnouncement": "{title} You completed {name}.",
        "steps": {
            "open-site-tool": {
                "title": "Create a site",
                "body": "This is LA County. Select the Create a Site tool {icon} to choose a place on the map.",
                "actionHint": "Select the Create a Site tool"
            },
            "click-parcel": {
                "title": "Pick a place",
                "body": "Click a parcel on the map to choose it as your site.",
                "actionHint": "Click a parcel on the map"
            },
            "read-data-insights": {
                "title": "View site data",
                "body": "Open Data Insights to get to know this place and see what opportunities exist in terms of heat, flooding, habitat and more.",
                "actionHint": "Open Data Insights"
            },
            "read-data-panel": {
                "title": "Explore the insights",
                "body": "Scroll through the data to learn more about this place and discover opportunities for improvement. Click any card to see its corresponding data layers on the map.",
                "actionHint": "Click any card to see its data layers on the map"
            },
            "open-layers": {
                "title": "Reveal the data",
                "body": "Turn on the Data Layers tool to visualize the conditions of this place.",
                "actionHint": "Turn on the Data Layers tool"
            },
            "toggle-rainfall": {
                "title": "Turn on Annual Rainfall",
                "body": "Click the Annual Rainfall layer to see on the map how much rain each area receives.",
                "actionHint": "Click the Annual Rainfall layer"
            },
            "click-readout": {
                "title": "Reveal the data",
                "body": "Click anywhere on the map to see the Annual Rainfall estimate for that spot.",
                "actionHint": "Click anywhere on the map"
            },
            "rainfall-aha": {
                "title": "Here’s what’s happening here!",
                "body": "That’s how much rain this spot gets each year. Every layer shows a different side to the story of the place. Close the data card when you’re done.",
                "actionHint": "Close the data card when you’re done"
            },
            "layer-guidebook": {
                "title": "Go deeper",
                "body": "Click the book icon on the Annual Rainfall row to open its guidebook page.",
                "actionHint": "Open the guidebook page"
            },
            "read-guidebook": {
                "title": "Take a peek at the guidebook",
                "body": "More information about this layer lives here — what it measures, why it matters, and where the data comes from. Have a look around, then close the guidebook when you’re done.",
                "actionHint": "Close the guidebook when you’re done"
            },
            "show-site-info": {
                "title": "Meet your site",
                "body": "Open Site Info to see everything about the place you just chose.",
                "actionHint": "Open Site Info"
            },
            "open-remedies": {
                "title": "Add a remedy",
                "body": "Click the Remedies tool to explore over 40 living infrastructure interventions you can add to your site.",
                "actionHint": "Click the Remedies tool"
            },
            "place-remedy": {
                "title": "Add a remedy to your site",
                "body": "Drag a remedy sticker from the tray and drop it onto your site.",
                "actionHint": "Drag a remedy onto your site"
            },
            "show-costs-benefits": {
                "title": "Weigh the impact",
                "body": "Open the Costs & Benefits tab to see how your remedies affect the site and the costs involved.",
                "actionHint": "Open the Costs & Benefits tab"
            },
            "read-costs-benefits": {
                "title": "Weigh it up",
                "body": "See the benefits your remedies bring to the site alongside its costs. Take a look, then close the panel.",
                "actionHint": "Close the panel when you’re done"
            },
            "open-comments": {
                "title": "Turn on comments",
                "body": "Click the comments button to activate the comments tool.",
                "actionHint": "Click the comments button"
            },
            "drop-comment-pin": {
                "title": "Drop a pin",
                "body": "Click anywhere on the map to leave a comment.",
                "actionHint": "Click anywhere on the map"
            },
            "choose-category": {
                "title": "Choose a category",
                "body": "Comment categories are optional, but can help keep comments organized. Open this menu to select one.",
                "actionHint": "Open the category menu"
            },
            "pick-category": {
                "title": "Which one fits?",
                "body": "Pick the category that best describes what you’re sharing.",
                "actionHint": "Choose a category"
            },
            "write-comment": {
                "title": "Write your comment",
                "body": "Add a comment, then click the yellow arrow or press Return to post it. You can also click on the clip icon below the text field to attach an image or document. Comments are visible to everyone in the project. What do you want to share?",
                "actionHint": "Write your comment, then click the yellow arrow or press Return"
            },
            "view-comments": {
                "title": "Browse your comments",
                "body": "Click the comment icon to open the panel to see all the comments that have been added to the map.",
                "actionHint": "Open the comments panel"
            },
            "open-a-comment": {
                "title": "All your comments live here",
                "body": "Click any comment to jump to it on the map. You can also sort, filter or hide comments from this panel.",
                "actionHint": "Click a comment in the panel"
            },
            "find-tutorials": {
                "title": "All tutorials live here",
                "body": "Open your account menu anytime to find and start another tutorial.",
                "actionHint": "Open your account menu to start another tutorial"
            },
            "sample-welcome": {
                "title": "Welcome to the Living Infrastructure Field Kit",
                "body": "This co-design tool helps plan and fund multi-benefit projects by integrating built, natural, and social systems to help people and places thrive. Let’s look at how living infrastructure helped revive Magic Johnson Park after years of misuse.",
                "actionHint": "",
                "manualLabel": "Next"
            },
            "sample-history": {
                "title": "Living infrastructure in action",
                "body": "Magic Johnson Park, once a polluted ExxonMobil site in Willowbrook, was renovated in 2021 through a partnership between Los Angeles County Department of Parks & Recreation, Los Angeles County Public Works, and Los Angeles County Development Authority. The park features an innovative stormwater system that diverts and treats runoff from surrounding communities to prevent flooding and pollution and to conserve water.",
                "actionHint": "",
                "manualLabel": "Next"
            },
            "sample-site": {
                "title": "The site",
                "body": "This outline is the site — the southern section of Magic Johnson Park, and the piece of the park this sketch plans for. Everything you see inside it was designed here in the Field Kit.",
                "actionHint": "",
                "manualLabel": "Next"
            },
            "sample-comments": {
                "title": "Community-driven needs",
                "body": "Pins like this one are comments, used to gather insights from community members and fieldwork during a project’s critical early phases. This one marks a need. Site studies and comments like it highlighted the area around the park as needing help with pollution, flooding, and access to green space.",
                "actionHint": "",
                "manualLabel": "Next"
            },
            "sample-opportunities": {
                "title": "What the data says",
                "body": "The site’s data tells you what it is already good at. Open Data Insights to see how this stretch of Willowbrook scores.",
                "actionHint": "Open Data Insights"
            },
            "sample-opportunities-list": {
                "title": "Data-driven flood resilience",
                "body": "Opportunities rank what this site is best positioned to deliver. Stormwater capture ranks high here — the lake can collect runoff from well beyond the park. That protects the community from flooding while creating a gathering space that adds jobs and improves public health.",
                "actionHint": "",
                "manualLabel": "Next"
            },
            "sample-remedies": {
                "title": "Designing with remedies",
                "body": "Stickers like this are remedies — the moves that make the design real. This sketch uses a storage pond, splash pad, community center, walking paths, and native gardens. The pond and wetland capture and filter runoff from the surrounding watershed, redirecting it to support habitat, irrigation, and the community here in Willowbrook.",
                "actionHint": "",
                "manualLabel": "Next"
            },
            "sample-explore": {
                "title": "Explore this sketch, then create your own!",
                "body": "Browse the comments, remedies, and benefits to see how living infrastructure evolved Magic Johnson Park. Costs shown here are educational and illustrative, and cover only the park’s southern section. What might you sketch for your own community? As longtime resident Willy puts it: “What this new park does for my community is it brings beauty to where tragedy once was. I’ve been here for over 64 years. I was here when this whole thing was nothing but old buildings and stuff like that. As far as I’m concerned, this is the best thing they could have done for Willowbrook.”",
                "actionHint": "",
                "manualLabel": "Done"
            }
        },
        "finale": {
            "understandingPlace": {
                "title": "Great work!",
                "body": "You’ve completed {name}. Any tutorial content you created has been saved and can be removed anytime. Ready to put your skills into practice? Explore the Field Kit on your own or try another tutorial."
            },
            "exploreMap": {
                "title": "Great work!",
                "body": "You’ve completed {name}. Any tutorial content you created has been saved and can be removed anytime. Ready to put your skills into practice? Explore the Field Kit on your own or try another tutorial."
            },
            "createProject": {
                "title": "Great work!",
                "body": "You’ve completed {name}. Any tutorial content you created has been saved and can be removed anytime. Ready to put your skills into practice? Explore the Field Kit on your own or try another tutorial."
            },
            "engageCommunity": {
                "title": "Great work!",
                "body": "You’ve completed {name}. Any tutorial content you created has been saved and can be removed anytime. Ready to put your skills into practice? Explore the Field Kit on your own or try another tutorial."
            },
            "sampleSketch": {
                "title": "Great work!",
                "body": "You’ve finished the tour of Magic Johnson Park. Ready to sketch your own vision? Explore the Field Kit on your own or try a guided tutorial."
            }
        }
    },
    "tooltipText": {
        "help": "Support",
        "menu": "Menu",
        "comment": "Comment"
    },
    "UILoadingIndicator": {
        "loading": "Loading...",
        "loadingAnimAltText": "An animation of three sequential pops, indicating loading in progress."
    },
    "MapControls": {
        "zoomIn": "Zoom in",
        "zoomOut": "Zoom out",
        "zoomAnnouncement": "Map zoomed to {level} percent",
        "layers": "Data layers",
        "pitch2D": "2D view",
        "pitch3D": "3D view",
        "pitch2DLabel": "Show map in 2D",
        "pitch3DLabel": "Show map in 3D",
        "sketchVisibility": "Visibility"
    },
    "BaseMapToggle": {
        "satelliteLabel": "Show satellite view",
        "streetLabel": "Show map view",
        "mapView": "Map view",
        "basemap": "Default",
        "satelliteOption": "Satellite"
    },
    "InfoHeader": {
        "landingTitle": "Living Infrastructure Field Kit",
        "landingTitleShort": "Field Kit",
        "menu": "Menu"
    },
    "MobileNavigation": {
        "landingTitleShort": "Field Kit",
        "menu": "Menu",
        "primers": "Primers",
        "guides": "Guides",
        "toggleLanguage": "Language"
    },
    "LanguageMenu": {
        "languageTag": "EN",
        "selectLanguage": "Select language"
    },
    "ContentMenu": {
        "contentMenu": "Resources",
        "primers": "Primers",
        "guides": "Guides"
    },
    "LoginControls": {
        "logIn": "Log in",
        "signUp": "Sign up",
        "visioningTool": "Visioning Tool"
    },
    "InfoFooter": {
        "logo": "The Living Infrastructure Field Kit",
        "livingInfrastructure": "Living Infrastructure",
        "home": "Home",
        "signUp": "Sign Up",
        "logIn": "Log In",
        "instagram": "Instagram",
        "linkedIn": "LinkedIn",
        "privacyPolicy": "Privacy Policy",
        "termsOfService": "Terms of Service",
        "attributionText": "Created with care and community by <a href=\"https://acceleratela.org/\" target=\"_blank\">Accelerate Resilience L.&nbsp;A. (ARLA)</a> and <a href=\"https://spherical.studio/\" target=\"_blank\">Spherical</a>. To be published under an open-source license. Accelerate Resilience L.&nbsp;A. is a sponsored project of Rockefeller Philanthropy Advisors.",
        "copyrightText": "Copyright ©2024 Living Infrastructure Field Kit. All rights reserved."
    },
    "unauthorizedText": {
        "instructions": "You are not authorized to view this page",
        "linkBack": "Go Home"
    },
    "Auth": {
        "welcomeHeading": "Welcome back!",
        "welcomeSubheading": [
            "“This is not our world with trees in it. It's a world of trees,</br> where humans have just arrived.”</br>—Richard Powers",
            "“Water is Life / Mní wičhóni.”</br>—Lakota phrase",
            "“Water begets water, soil is the womb,</br>vegetation the midwife.”</br>—Millán Millán",
            "“Infrastructural citizenship is not just care at scale,</br>but care in perpetuity.”</br>—Deb Chachra",
            "“All that you touch You Change.</br>All that you Change Changes you.”</br>—Lauren Oya Olamina (Octavia E. Butler)",
            "“Ecosystems are so similar to human societies—</br>they’re built on relationships. The stronger those are, the</br>more resilient the system.”</br>—Suzanne Simard",
            "“Los Angeles is a bowl of water; it is filled up; it is free.”</br>—Megan Dorame",
            "“Life did not take over the world by combat, but by networking.”</br>—Lynn Margulis",
            "“All life-forms are in fact processes not things.”</br>—Merlin Sheldrake"
        ],
        "emailLabel": "Email",
        "passwordLabel": "Password",
        "emailValidation": "Please enter a valid email address",
        "passwordValidation": "Please enter a password",
        "passwordMinLengthValidation": "Password must be at least 8 characters",
        "emailPlaceholder": "Enter email",
        "passwordPlaceholder": "Enter password",
        "confirmPlaceholder": "Confirm password",
        "footerText": "Created with care and community by <a class=\"underline\" target=\"_blank\" href=\"https://acceleratela.org/\"> Accelerate Resilience L. A. (ARLA)</a> and <a class=\"underline\" target=\"_blank\" href=\"https://spherical.studio/\">Spherical</a>. To be published under an open-source license. Accelerate Resilience L.A. is a sponsored project of Rockefeller Philanthropy Advisors.",
        "termsLinkText": "Terms of Service",
        "privacyLinkText": "Privacy Policy",
        "handsImageAltText": "In a colorful animation, a leafy branch, storm water drain, and several clasped human hands form a braid, representing the built, natural, and social systems underlying living infrastructure.",
        "treeImageAltText": "In a colorful animation, a person waters a lemon tree with rainwater from a cistern. Worms, frogs, butterflies, mushrooms, and flowers emerge where the water pools at the base of the tree.",
        "checkOut": "Check out the Field Kit on your own."
    },
    "LoginView": {
        "forgotPassword": "Forgot password?",
        "formHeader": "Log in",
        "buttonText": "Log In",
        "signUpText": "Need an account?",
        "signUpLinkText": "Sign up",
        "errorMessage": "Incorrect login",
        "butterflyImageAltText": "Animation of a butterfly, a worm and several plant and flowers flying in the wind"
    },
    "SignupView": {
        "welcomeHeading": "Welcome!",
        "welcomeSubheading": "The Field Kit includes a free co-design tool and learning resources to help communities envision, plan, and apply for funding for multi-benefit projects.",
        "whenYouSignup": "When you sign up, you can:",
        "identifySiteOpportunities": "Identify site opportunities for living infrastructure",
        "useData": "Use data to understand places",
        "inviteCommunity": "Invite community participation",
        "sketchTogether": "Sketch together to envision new project ideas",
        "learn": "Learn about the costs and benefits of your design",
        "download": "Download project proposals",
        "watch": "Watch a video overview",
        "formHeader": "Sign up",
        "buttonText": "Create Account",
        "logInText": "Already have an account?",
        "logInLinkText": "Log in",
        "firstNameLabel": "First Name",
        "lastNameLabel": "Last Name",
        "organizationLabel": "Organization (optional)",
        "organizationPlaceholder": "Enter organization",
        "firstNamePlaceholder": "Enter first name",
        "lastNamePlaceholder": "Enter last name",
        "privacyLabel": "I agree to the <a class=\"underline\" target=\"_blank\" href=\"https://livinginfrastructure.org/terms\">Terms of Service</a> and <a class=\"underline\" target=\"_blank\" href=\"https://livinginfrastructure.org/privacy\">Privacy Policy</a>",
        "marketingLabel": "I want to receive emails with tips, product updates, and more (optional)",
        "privacyError": "Please accept our terms and privacy policy",
        "firstNameError": "Please enter your first name",
        "lastNameError": "Please enter your last name",
        "errorMessage": "Error signing up",
        "errorAccountExists": "An account with this email already exists",
        "errorNoShareToken": "Please provide a valid collaborator link",
        "polygonAlt": "A four-sided polygon with green circles at the vertices and a plus in the center.",
        "dataLayersAlt": "Three squares viewed from an angle are stacked, floating, on top of each other, with the bottom square being dark blue and the others progressively lighter.",
        "sketchAlt": "Four colorful shapes are arranges in two rows.",
        "guidebookAlt": "A open book with a blue cover, pages facing upward.",
        "exportAlt": "A red pencil hovers over an orange paper with writing on it."
    },
    "SignupButton": {
        "buttonText": "Sign up"
    },
    "ForgotPasswordView": {
        "formHeader": "Forgot your password?",
        "formSubheader": "To reset your password, enter your email and we'll send you a link.",
        "buttonText": "Send Me Reset Link",
        "linkBack": "Return to login page",
        "successHeader": "Instructions sent!",
        "successSubHeader": ["Check your email at ", "and follow instructions"],
        "errorMessage": "Error resetting your password",
        "birdAltText": "Image of a bird flying."
    },
    "PasswordResetView": {
        "welcomeHeading": "Welcome to the Visioning Tool",
        "welcomeSubheading": "Set the password for your account.",
        "formHeader": "Enter New Password",
        "passwordPlaceholder": "Enter new password",
        "confirmPlaceholder": "Confirm new password",
        "newPasswordLabel": "New password",
        "confirmPasswordLabel": "Confirm password",
        "confirmLabel": "Confirm password",
        "buttonText": "Change Password and Login",
        "linkBack": "Return to login page",
        "passwordConfirmationValidation": "Please enter a password confirmation",
        "passwordsMustMatch": "Passwords must match",
        "errorMessage": "Your password could not be set",
        "loading": "Loading…"
    },
    "PrivacyModal": {
        "formHeader": "Updated Privacy Policy",
        "formSubheader": "Welcome back. We have published a new <a class=\"underline\" target=\"_blank\" href=\"https://livinginfrastructure.org/terms\">Terms of Service</a> and <a class=\"underline\" target=\"_blank\" href=\"https://livinginfrastructure.org/privacy\">Privacy Policy</a> as part of our public launch. Please review and agree to continue using the Living Infrastructure Field Kit.",
        "buttonText": "I agree",
        "errorMessage": "Please accept the terms and privacy policy to continue"
    },
    "WorkshopsGrid": {
        "loading": "Loading projects",
        "loadError": "Projects could not be loaded…",
        "noWorkshops": "No project created yet",
        "createNew": "New Project"
    },
    "WorkshopCard": {
        "edit": "Edit project",
        "duplicate": "Project duplicated.",
        "sampleSketch": "Sample project",
        "sampleSketchTooltip": "Explore this park’s transformation to see how living infrastructure can reshape your community."
    },
    "SketchModal": {
        "createHeader": "Create a new project",
        "editHeader": "Rename project",
        "nameLabel": "Name*",
        "delete": "Delete",
        "cancelWarningHeading": "Are you sure you want to discard this project?",
        "cancelWarning": "Once you discard this project, you will not be able to access it again.",
        "cancelUpdateWarningHeading": "Are you sure you want to discard these project changes?",
        "cancelUpdateWarning": "Once you discard, your project changes will not be saved. ",
        "submitWorkshopError": "Your project cannot be saved at the moment. We suggest resetting your internet connection or finding a faster one. If that doesn’t work, bear with us as we resolve the issue on our end. Thank you for your patience!",
        "nameValidation": "Please enter a name",
        "deleteConfirmation": "Are you sure you want to delete this project? Once you delete, you will not be able to access it again.",
        "deleteWorkshopError": "Your project cannot be deleted at the moment. We suggest resetting your internet connection or finding a faster one. If that doesn’t work, bear with us as we resolve the issue on our end. Thank you for your patience!",
        "submit": "Submit",
        "showCosts": "Show costs",
        "showCostsInfoTip": "Displays total creation and care costs for your project in the profile panel.",
        "save": "Save",
        "toggleCosts": "Toggle Cost Visibility"
    },
    "EditUserModal": {
        "headline": "Edit user",
        "label0": "First name",
        "label1": "Last name",
        "label2": "Email address",
        "label3": "Role",
        "cancelButton": "Cancel",
        "button": "Update",
        "delete": "Delete",
        "submitUserError": "The user could not be updated",
        "deleteUserError": "The user could not be deleted",
        "firstNameValidation": "Please enter a first name",
        "lastNameValidation": "Please enter a last name",
        "emailValidation": "Please enter a valid email address",
        "loading": "Loading user…"
    },
    "SearchControl": {
        "search": "Search",
        "searchFor": "Search for a place..."
    },
    "TopNavbar": {
        "export": "Export",
        "share": "Share"
    },
    "HomeButton": {
        "backToHome": "Return home",
        "home": "Home"
    },
    "LogoLink": {
        "lifk": "Living Infrastructure Field Kit"
    },
    "NavBreadcrumbs": {
        "projectDefault": "Project",
        "breadcrumbs": "Breadcrumbs"
    },
    "ProjectName": {
        "projectDefault": "Project",
        "projectName": "Project name",
        "clickToSelect": "Click to select the project",
        "editProject": "Edit project"
    },
    "ProjectNameInput": {
        "projectName": "Project name",
        "saveSuccess": "Project name updated",
        "nameValidationError": "Please enter a project name",
        "duplicateNameWarning": "A project already exists with this name. Please try a different name.",
        "saveError": "An error occured while saving",
        "editInstructions": "Enter your project name, then click Enter to submit and save"
    },
    "SiteDropdown": {
        "mySites": "My Sites",
        "site": "Site",
        "sites": "Sites",
        "selectASite": "Select a site",
        "createASite": "Create a site",
        "emptyProject": "Create a site to get data insights, design with remedies, and more.",
        "unauthEmptyProject": "This project doesn't have any sites. Ask the project owner to create a site to get started."
    },
    "ShareModal": {
        "header": "Share",
        "submitText": "Invite",
        "emailValidation": "Please enter valid email addresses",
        "emailLimitError": "You can invite a maximum of 25 email addresses at once.",
        "roleValidation": "Please select a role",
        "accessHeader": "People with Access",
        "inviteSuccess": "Invitations sent to collaborators",
        "collaboratorRemoved": "Collaborator removed from this project.",
        "generalError": "Error inviting collaborators.",
        "alreadyInvited": "has already been invited to this project.",
        "alreadyACollaborator": "is already a collaborator on this project.",
        "singleCollaboratorError": "could not be added as a collaborator.",
        "publicLinkLabel": "Public link",
        "publicLinkLabelInfoTooltip": "Anyone with the public link can <span class=\"md:hidden\"><br></span> access this project without an account. <span class=\"md:hidden\"><br></span> <a class='underline' target='_blank' href='https://help.la.livinginfrastructure.org/en/articles/9930995-sharing-sketches'>Learn more</a>",
        "publicLinkEnableTooltip": "Enable public link",
        "publicLinkDisableTooltip": "Disable public link",
        "publicLinkDescription": "When visitors access this link, the map will zoom in to your content. If you do not have any content yet, consider creating a site before sharing.",
        "publicLinkRolesDescription": "Anyone with a public link can",
        "publicLinkSuccess": "Link copied!",
        "publicLink": "Copy link",
        "publicLinkRoles": {
            "contributor": "Contribute",
            "viewer": "View only"
        },
        "roleDropdownTooltipEditor": "As an editor, you are unable to edit public link access",
        "publicLinkRoleLabel": "Public link permission"
    },
    "CollaboratorEmailsInput": {
        "inviteHeader": "Invite Collaborators",
        "tooltipText": "Collaborators can edit the project <span class=\"md:hidden\"><br></span> and must have an account.<span class=\"md:hidden\"><br></span> <a class='underline' target='_blank' href='https://help.la.livinginfrastructure.org/en/articles/9930995-sharing-sketches'>Learn more</a>",
        "emailPlaceholder": "Enter emails separated by commas",
        "remove": "Remove",
        "infoIconTooltip": "Information about collaborator permissions and requirements",
        "roleLabel": "Collaborator permission"
    },
    "PublicSketchClosedView": {
        "header": "is&nbsp;closed",
        "bodyOne": "Thank you for your interest in contributing to the",
        "bodyTwo": "The opportunity to collaborate on this project is now closed. If you would like to get in touch, reach out to",
        "bodyThree": "directly.",
        "CTAAnon": "Check out the Field Kit on your own.",
        "buttonTextAnon": "Sign up",
        "buttonTextUser": "Return home",
        "organizationDefault": "this organization"
    },
    "CollaboratorRow": {
        "remove": "Remove",
        "confirmRemoveHeading": "Are you sure you want to remove access?",
        "confirmRemove": "Once you remove a person's access, they will not be able to participate in this project.",
        "inviteSent": "invite sent",
        "user": "user",
        "permissionLabel": "Permission for"
    },
    "MapToolbar": {
        "comments": "Add comments",
        "guidebook": "Guidebook",
        "layers": "Data layers",
        "remedies": "Add remedies",
        "createSite": "Create a site",
        "editSite": "Edit site",
        "createStory": "Create a story"
    },
    "UICloseButton": {
        "close": "Close"
    },
    "OnboardingDialog": {
        "firstTimeUseHeader": "Start exploring",
        "firstTimeUseDescription": "Find and create a site to learn about a place, and explore living infrastructure remedies.",
        "firstTimeUseButtonText": "Find a place",
        "onboardingHeader": "Get to know a place",
        "onboardingDescription": "Create a site to explore land use, ownership, boundaries, watersheds, and Indigenous territories.",
        "onboardingButtonText": "Create a site"
    },
    "UICollapseButton": {
        "expand": "Expand",
        "collapse": "Collapse"
    },
    "LayersPanel": {
        "title": "Data Layers",
        "closePanel": "Close data layers panel",
        "searchPrompt": "Search for a data layer...",
        "clearSearch": "Clear search",
        "viewBy": "View by:",
        "azView": "A-Z",
        "packView": "Pack",
        "noPackResults": "No pack matches for this search. Matching layers are available in the A-Z list.",
        "viewAZResults": "View A-Z results"
    },
    "PackLayers": {
        "showAll": "Show non-matching layers",
        "showLess": "Hide non-matching layers"
    },
    "UINavMenu": {
        "logIn": "Log in",
        "logInDescription": "to create your own sites, design remedies, and more.",
        "knowledgeBase": "Help center",
        "contact": "Support",
        "tutorials": "Guided tutorials",
        "logout": "Log out",
        "toggleLanguage": "Language",
        "export": "Export",
        "share": "Share",
        "guidebook": "Guidebook",
        "sphericalAdmin": "Spherical admin",
        "profile": "Profile",
        "commPref": "Communication preferences"
    },
    "AccountLanguage": {
        "languagePreferences": "Language preferences"
    },
    "AccountMenuHeader": {
        "anonymous": "Anonymous",
        "workshopAdmin": "Admin",
        "editor": "Editor",
        "contributor": "Contributor",
        "viewer": "Viewer",
        "guest": "Guest",
        "workshopAdminTooltip": "You can create and edit sites, add remedies and leave comments. You can also invite and remove collaborators and manage their roles.",
        "editorTooltip": "You can create and edit sites, add remedies and leave comments. You can also invite collaborators.",
        "contributorTooltip": "You can add remedies and leave comments.",
        "viewerTooltip": "You can view sites and react to remedies."
    },
    "UISticker": {
        "sticker": "Sticker"
    },
    "UISettingsButton": {
        "settings": "Settings"
    },
    "SketchBanner": {
        "start": "Click to add points and draw your site.",
        "sketchReadyToClose": "Click either endpoint at any time to complete the shape and create your site.",
        "edit": "Edit your site by adding, deleting, and moving points.",
        "resize": "Click and drag any point to scale your site.",
        "parcelSelect": "Click an area on the map to create a site.",
        "guestSavePrompt": "To save your site, create a free account or log in.",
        "userSavePrompt": "Save your site to add remedies",
        "saveAndSignup": "Save and sign up",
        "save": "Save",
        "cancel": "Cancel"
    },
    "RemedyTooltip": {
        "footprint": "Footprint: ",
        "aboveground": "Above Ground",
        "belowground": "Below Ground",
        "canopy": "Canopy",
        "ground": "Ground",
        "totalFootprintWarning": "This remedy is larger than your site’s total footprint.",
        "sumFootprintsWarning": "This remedy is larger than your site’s remaining footprint.",
        "learnMore": "Learn More",
        "perYear": "/year"
    },
    "FootprintBanner": {
        "edit": "Edit your remedy footprint by adding, deleting, and moving points.",
        "rotate": "Click and drag to rotate your footprint.",
        "resize": "Click and drag any point to scale your footprint.",
        "save": "Save",
        "cancel": "Cancel"
    },
    "EditModeMenu": {
        "edit": "Edit",
        "scale": "Scale",
        "rotate": "Rotate",
        "fixedFootprint": "This remedy has a fixed footprint size"
    },
    "EffectsBanner": {
        "added": "added",
        "remedyOutsidePolygon": "Remedy is outside of your site. Drag it inside the site bounds to include it.",
        "missingOut": "You are missing out on",
        "sqftAdded1": "",
        "sqftAdded2": "sqft added to",
        "sqftRemoved1": "",
        "sqftRemoved2": "sqft removed from"
    },
    "WarningBanner": {
        "totalFootprintBanner": "You added a remedy larger than your site’s total footprint.",
        "sumFootprintsBanner": "Your remedies now exceed the site's footprint.",
        "rateLimited": "Too much is happening at once, so your last change wasn’t saved. This should clear up in a moment.",
        "siteTooLarge": "This site exceeds the limit of 100M sqft for calculating and exporting metrics, but you may continue sketching.",
        "atLeast3Points": "Remedy footprints need at least 3 points.",
        "invalidSitePolygon": "Site edges cannot intersect.",
        "invalidFootprintPolygon": "Footprint edges cannot intersect.",
        "aqueductshedsLayer": "This layer covers several U.S. states; you may need to zoom out to see it.",
        "zoomIn": "Zoom in to see $dataLayerNames data.",
        "zoomOut": "Zoom out to see $dataLayerNames data.",
        "zoomBoth": "Adjust the zoom level to see $dataLayerNames details.",
        "and": "and"
    },
    "CostsSummary": {
        "outOf": "out of",
        "cost": "Cost",
        "care": "Care"
    },
    "BenefitsSummary": {
        "benefits": "collective"
    },
    "SiteInformationPanel": {
        "information": "Information",
        "coordinates": "Coordinates",
        "site": "Site",
        "siteFootprint": "Site footprint",
        "location": "Location"
    },
    "BudgetSection": {
        "budget": "Budget",
        "editBudget": "Edit site budget",
        "creation": "Creation",
        "annualCare": "Annual Care",
        "creator": "Creator",
        "creatorTip": "The creator will be credited as the author of the site in any exports.",
        "creationBudget": "Creation Budget",
        "creationBudgetTipProject": "This is the target maximum up-front cost for your project, based on the combined budgets of all your sites—including planning, design, and construction.\n\nIf budgets have not been entered for any of your sites, default budgets will be used based on the size of each of those sites.",
        "creationBudgetTipSite": "This is the target maximum up-front cost for your site, including planning, design, and construction.\n\nIf you do not enter a budget, a default budget will be used based on the size of your site.",
        "annualCareBudget": "Annual Care Budget",
        "annualCareBudgetTipProject": "This is the target maximum annual cost for your project, based on the combined budgets of all your sites—including operations, maintenance, and monitoring. This cost can be multiplied by your project lifespan to calculate a total care cost.\n\nIf budgets have not been entered for any of your sites, default budgets will be used based on the size of each of those sites.",
        "annualCareBudgetTipSite": "This is the target maximum annual cost for your site, including operations, maintenance, and monitoring. This cost can be multiplied by your project lifespan to calculate a total care cost.\n\nIf you do not enter a budget, a default budget will be used based on the size of your site."
    },
    "UISkeleton": {
        "mapMarker": "Map marker"
    },
    "GuidebookRemedySpecs": {
        "creation": "Creation",
        "care": "Care",
        "perYear": "/year",
        "creationIcon": "Creation cost icon",
        "creationTooltip": "The up-front cost of planning, design, and implementation",
        "creationTooltipEditable": "The up-front cost of planning, design, and implementation for the default footprint",
        "careIcon": "Care cost icon",
        "careTooltip": "The annual cost of maintenance, operations, and monitoring",
        "careTooltipEditable": "The annual cost of maintenance, operations, and monitoring for the default footprint",
        "footprintTooltip": "The default surface area (not editable)",
        "footprintTooltipEditable": "The default surface area (editable)",
        "placement": "Placement",
        "placementIcon": "Placement icon",
        "footprint": "$size footprint",
        "editable": "editable",
        "notEditable": "not editable",
        "extraLarge": "Extra large",
        "large": "Large",
        "medium": "Medium",
        "small": "Small"
    },
    "StormwaterSection": {
        "water": "Water",
        "none": "None"
    },
    "RainfallCard": {
        "roofRainfall": "Roof Rainfall",
        "onsite": "Onsite",
        "offsite": "Offsite",
        "totalRainfall": "Total Rainfall",
        "runoff": "Runoff",
        "onsiteTooltip": "The amount of rainwater falling on your site or roof, which can be collected using smaller remedies",
        "offsiteTooltip": "The amount of stormwater runoff flowing within 250 feet of your site (on the surface or in storm drains), which could be diverted to larger sites for collection using larger remedies",
        "personYearsDisclaimer": "Person-years represent the population who could be supplied with water for a year, based on the California standard of 17,155 gallons per person."
    },
    "ResponseActions": {
        "edit": "Edit",
        "delete": "Delete",
        "cancel": "Cancel",
        "save": "Save",
        "actionsMenu": "Comment actions menu",
        "repliesSingular": "reply",
        "repliesPlural": "replies",
        "menuActions": "Menu actions",
        "userProfilePicture": "User profile picture for",
        "anonymous": "ANONYMOUS"
    },
    "UIEmailIcon": {
        "userProfilePicture": "User profile picture for"
    },
    "ShowDraftComment": {
        "commentMapMarker": "Comment map marker"
    },
    "CommentMapMarker": {
        "closedMarker": "Closed Comment Map Marker",
        "userProfilePicture": "User profile picture"
    },
    "CommentsLayer": {
        "unread": "unread",
        "replies": "replies",
        "commentBy": "Comment by"
    },
    "CommentPopup": {
        "comment": "Comment",
        "confirmDeleteHeading": "Are you sure you want to delete this comment?",
        "confirmDelete": "Once you delete a comment, you and everyone in this project will lose access to it.",
        "edit": "Edit",
        "delete": "Delete",
        "cancel": "Cancel",
        "save": "Save",
        "submitButton": "Submit comment",
        "actionsMenu": "Comment actions menu",
        "mapMarker": "Comment map marker",
        "addReplyPlaceholder": "Add your reply…",
        "submitReply": "Submit reply",
        "confirmDeleteReplyHeading": "Delete Reply?",
        "confirmDeleteReply": "Are you sure you want to delete this reply? Once you delete, you will not be able to access it again.",
        "confirmDeleteThreadHeading": "Delete Thread?",
        "confirmDeleteThread": "Are you sure you want to delete this thread? Once you delete, you will not be able to access it again."
    },
    "UIBodyPopup": {
        "placeholderComment": "Add your comment...",
        "submitComment": "Submit comment"
    },
    "UICommentCategoryTag": {
        "chooseCategory": "Choose a category"
    },
    "UICommentCategorySelect": {
        "title": "Category",
        "header": "Choose a category",
        "menuAriaLabel": "Comment categories",
        "description": "Categories are optional and can help keep comments organized.",
        "emptyState": "Add a new category to make it available for project collaborators. Categories are optional and can help keep comments organized.",
        "addCategory": "Add new category",
        "editCategory": "Edit category",
        "aboutCategory": "About this category"
    },
    "CommentCategoryModal": {
        "newCategory": "New Category",
        "editCategory": "Edit Category",
        "nameLabel": "Name",
        "nameYourCategory": "Name your category",
        "nameValidation": "Please enter a name for your category.",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Describe your category or give examples",
        "icon": "Icon",
        "selectIcon": "Select an icon",
        "iconValidation": "Please select an icon.",
        "save": "Save",
        "delete": "Delete",
        "saveError": "That category could not be saved. Please try again.",
        "deleteError": "That category could not be deleted. Please try again.",
        "confirmDeleteHeading": "Delete Category?",
        "confirmDelete": "Are you sure you want to delete this category? Deleting it will remove it from all comments that have been assigned this category.",
        "confirmCloseHeading": "Are you sure you want to discard changes to these category details?",
        "confirmClose": "Once you choose discard, you will not be able to access them again."
    },
    "UIIconPickerMenu": {
        "title": "Select an icon",
        "searchPlaceholder": "Search for an icon...",
        "searchAriaLabel": "Search icons",
        "clearSearch": "Clear search",
        "noResults": "We couldn’t find any matches."
    },
    "UIFileUploadButton": {
        "maxFiles": "You can only upload up to 5 files at a time.",
        "attachFile": "Attach up to 5 files",
        "fileTooLarge": "is too big to upload. Please choose a file smaller than",
        "forbiddenFileType": "is not a supported file type.",
        "maxFilesReached": "You can only upload up to 5 files at a time.",
        "imageModerationFailure": "may contain harmful content and violate our Terms of Service. If you believe this decision was made in error, please contact our support team."
    },
    "UIFilePreview": {
        "remove": "Remove",
        "clickToView": "Click to view"
    },
    "CostsBenefitsPanel": {
        "projectCosts": "Project Costs",
        "siteCosts": "Site Costs",
        "remedyBenefits": "Remedy Benefits",
        "mobileVisitDesktopProject": "Visit desktop to add remedies and see the impact of your project",
        "mobileVisitDesktopAllSites": "Visit desktop to add remedies and see the impact of your sites",
        "mobileVisitDesktopSite": "Visit desktop to add remedies and see the impact of your site",
        "mobileVisitDesktopAlt": "An illustration of pollution.",
        "effects": "Total Effects",
        "globalEffects": "Global Effects",
        "fullBar": "A full bar represents the most points a site of this size could reasonably achieve",
        "defaultBudgetFullBar1": "Budget defaults to",
        "userSetBudgetFullBar1": "Custom budget set to",
        "budgetFullBar2": "You can set your own custom amount in",
        "budgetFullBarLink": "Site Details",
        "total": "Total",
        "disclaimer": "Forecasts are currently in beta, and we are refining our calculations based on input from people like you. If anything looks strange, let us know.",
        "totalCost": "Total Cost",
        "globalCost": "Global Costs",
        "remediesOutsideWarning": "Remedies placed outside the site are not counted in the score. Drag all remedies into your site to include their effects.",
        "footprintWarning1": "Your remedies exceed the site's",
        "footprintWarning2": "footprints. Consider removing one or more.",
        "and": "and",
        "aboveground": "above ground",
        "belowground": "below ground",
        "canopy": "canopy",
        "ground": "ground",
        "icon": "icon",
        "outsideLAWarning": "Calculations may be less accurate for sites outside of LA county."
    },
    "UIReferenceIcon": {
        "learnMore": "Learn More",
        "ariaLearnMore": "Open guidebook to learn more"
    },
    "RemediesLayer": {
        "submitNoteError": "Your notes could not be updated at this time.",
        "confirmDeleteHeading": "Are you sure you want to delete this remedy?",
        "confirmDelete": "Once you delete a remedy, you and everyone in this workshop will not be able to access it.",
        "remedy": "remedy",
        "squareFeet": "square feet",
        "remedyMarker": "remedy marker",
        "dollars": "dollars",
        "likeRemedy": "Like this remedy",
        "unlikeRemedy": "Unlike this remedy",
        "likeCount": "likes"
    },
    "RemedyContextMenu": {
        "learn": "Learn",
        "customize": "Notes",
        "duplicate": "Copy",
        "delete": "Delete",
        "editFootprint": "Edit footprint"
    },
    "RemedyNoteModal": {
        "cancelWarningHeading": "Are you sure you want to discard this note’s changes?",
        "cancelWarning": "Once you discard, your note’s changes will not be saved. ",
        "title1": "Add",
        "title2": "Details",
        "notes": "notes"
    },
    "SiteContextMenu": {
        "duplicate": "Copy",
        "delete": "Delete",
        "editPoly": "Edit shape"
    },
    "SelectSketchDropdown": {
        "selectProject": "Select Site"
    },
    "BudgetModal": {
        "editBudget": "Edit Budget",
        "budgetLabel": "Budget",
        "budgetValidation": "Budget must be a valid dollar amount.",
        "confirmCloseHeading": "Are you sure you want to discard your budget changes?",
        "confirmClose": "Once you discard your budget changes, you will not be able to access them again.",
        "updateSketchError": "Your site cannot be updated at the moment. We suggest resetting your internet connection or finding a faster one. If that doesn’t work, bear with us as we resolve the issue on our end. Thank you for your patience!",
        "done": "Done",
        "defaultBudgetInfo": "This is a default budget based on the total size of your site",
        "defaultBudget": "Default budget",
        "customBudgetInfo": "based on the size of your site"
    },
    "ShowCostsToggle": {
        "showCostsInfoTipProject": "Controls visibility of project costs, budgets, and costs for remedies you add to your project.",
        "showCostsInfoTipSite": "Controls visibility of site costs, budgets, and costs for remedies you add to your project.",
        "toggleCosts": "Toggle Cost Visibility",
        "showCosts": "Show costs"
    },
    "SiteDetailsModal": {
        "siteDetails": "Site Details",
        "nameLabel": "Name*",
        "creatorLabel": "Creator",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Why have you created this Site? Why is this Site important to you and your community?",
        "nameValidation": "Required field. Please name your site.",
        "nameLengthValidation": "Name must be fewer than 68 characters.",
        "creatorLengthValidation": "Creator name must be fewer than 68 characters.",
        "confirmCloseHeading": "Are you sure you want to discard these Site details?",
        "confirmClose": "Once you discard these Site details, you will not be able to access them again.",
        "duplicateNameError": "A site already exists with this title. Please try a different title.",
        "updateSketchError": "Your site cannot be updated at the moment. We suggest resetting your internet connection or finding a faster one. If that doesn’t work, bear with us as we resolve the issue on our end. Thank you for your patience!",
        "done": "Done"
    },
    "ExportsContainer": {
        "genericError": "Your export cannot be completed at the moment. We suggest resetting your internet connection or finding a faster one. If that doesn’t work, bear with us as we resolve the issue on our end. Thank you for your patience!"
    },
    "ExportModal": {
        "exportSketch": "Export",
        "selectTool": "What would you like to export?",
        "exportFormat": "Export Format",
        "CSV": "CSV",
        "PDF": "PDF",
        "DOCX": "DOCX",
        "JPG": "JPEG (High-Resolution Image)",
        "helpCenter": "Learn more about exports and formats",
        "toolRequiredError": "Please select at least one thing to export.",
        "exportIsLoading": "Exporting may take a few minutes. You can click out of the modal to continue working as it downloads.",
        "sites": "Sites",
        "comments": "Comments",
        "export": "Export",
        "noData": "There was no data to export.",
        "loadingAnimAltText": "An animation of two long-legged birds standing in water. One periodically stretches its neck an flaps its wings."
    },
    "CommonSiteProfile": {
        "projectName": "Project Name",
        "datetimeCreated": "Datetime Created (UTC)",
        "name": "Name",
        "creator": "Creator",
        "description": "Description",
        "remedies": "Remedies",
        "sqft": "sqft",
        "benefits": "Benefits",
        "opportunities": "Opportunities",
        "siteBy": "Site created by",
        "siteDisclaimer": "This provides a high-level vision for what the site might look like. It is not intended to be a vetted design proposal and is subject to feasibility analysis, detailed design, and permitting.",
        "benefitsSubtext": "These benefits are modeled exclusively based on the remedies included in the site. The benefits do not take into consideration site conditions, such as the amount of runoff available for stormwater collection, which should be evaluated independently. They are modeled empirically to demonstrate the relative amount of each anticipated benefit, and a full bar represents the highest reasonable benefit that could be achieved given the footprint of the site. These values are subject to more rigorous performance analysis of detailed designs.  For more information on data methodology, visit the Living Infrastructure Field Kit at livinginfrastructure.org.",
        "costsSubtext": "These costs are modeled exclusively based on the remedies included on the site. They do not consider site-specific costs, such as soil remediation or utilities relocation, which should be evaluated independently. The estimates are based on local materials and labor costs over the designated project lifespan.  For more information on data methodology, visit the Living Infrastructure Field Kit at livinginfrastructure.org.",
        "stormwaterSubtext": "The rainfall figures are estimated based on the amount of rainfall that falls on the site during an average year or an 85th percentile storm event. The runoff contribution area and offsite runoff calculations are based on the runoff that flows within 250 feet of the site (aboveground or in storm drains).  For more information on data methodology, visit the Living Infrastructure Field Kit at livinginfrastructure.org.",
        "creationSubheader": "Planning, design, and construction",
        "careSubheader": "Annual maintenance, operations, and monitoring",
        "opportunitiesSubtext": "Opportunities are based on available data and relative to LA County. A high level indicates improvements may be needed. This data should be supplemented with community input and site studies. For more information on data methodology, visit the Living Infrastructure Field Kit at livinginfrastructure.org.",
        "landSubtext": "Land cover is based on aerial imagery and lidar data. For more information on data methodology, visit the Living Infrastructure Field Kit at livinginfrastructure.org.",
        "existingProjectsSubheader": "L.A. County Measure W, Measure A, and Infrastructure LA Projects within site walkshed",
        "annualAverage": "Average Year",
        "stormEvent": "85th percentile storm",
        "runoffContributionArea": "Offsite Runoff Contribution Area",
        "total": "Total",
        "noGroundwaterBasin": "No Groundwater Basin",
        "inhr": "in/hr",
        "Very High": "Very High",
        "High": "High",
        "Moderate": "Moderate",
        "Low": "Low",
        "Very Low": "Very Low",
        "Unknown": "Unknown",
        "noDataAvailable": "No data available for your region",
        "siteRainfall": "Site Rainfall",
        "offsiteRunoff": "Offsite Runoff",
        "siteFooterText": "This site was designed using the Living Infrastructure Field Kit.",
        "footerText2": "Created with care and community by Accelerate Resilience L. A. (ARLA) and Spherical. To be published under an open-source license. Accelerate Resilience L. A. is a sponsored project of Rockefeller Philanthropy Advisors.",
        "footerText3": "livinginfrastructure.org"
    },
    "DataLayerPopup": {
        "hide": "Hide",
        "layerDetails": "Layer Details",
        "loading": "Loading...",
        "noData": "No Data"
    },
    "HideLayerButton": {
        "show": "Show",
        "hide": "Hide"
    },
    "MapLegend": {
        "heading": "Legend",
        "expand": "Expand Legend",
        "collapse": "Collapse Legend"
    },
    "PopupFeatureItem": {
        "visitWebsite": "Visit website",
        "inch": "inch",
        "inches": "inches",
        "feet": "feet",
        "sqft": "sqft",
        "acres": "acres",
        "meters": "meters",
        "miles": "miles",
        "sqmi": "square miles",
        "count": "count",
        "in": "inches",
        "percent": "%",
        "%": "%",
        "dollars": "dollars",
        "gal": "gallons",
        "tons": "tons",
        "percentile": "percentile",
        "years": "years",
        "coordinate": "coordinate",
        "F": "°F",
        "fahrenheit": "°F",
        "in/hr": "in/hr"
    },
    "LayerName": {
        "layer": "$layerName layer",
        "removeLayer": "Remove $layerName layer",
        "learnMore": "Learn more about"
    },
    "SketchLayersMenu": {
        "sites": "Sites",
        "comments": "Comments",
        "footprints": "Remedy Footprints",
        "remedies": "Remedies",
        "sketchVisibility": "Visibility",
        "sitesIconAlt": "A four sided polygon representing a site",
        "remediesIconAlt": "A cloud shaped sticker representing remedies",
        "footprintsIconAlt": "A pair of footprints that toggles footprints",
        "commentIconAlt": "A pair of speech bubbles representing comments"
    },
    "LevelArrows": {
        "positive": "positive",
        "negative": "negative",
        "outOf": "out of",
        "arrows": "arrows"
    },
    "IdentifyStressors": {
        "heading": "Identify Stressors",
        "subhead": "Video series",
        "description": "<p class=\"mb-4\">Communities across L.A. County experience different stressors, from heat exposure to air pollution. These stressors are worsened by historic disinvestment, poor land use, and climate change. Identifying stressors is an important step in designing living infrastructure to address our communities' needs.</p><p>This series spotlights Angelenos talking about stressors that affect them where they live. Where do you see stressors like these in your community? What are the causes? What are the effects?</p>",
        "shadeEquity": "Shade Equity",
        "highwayPollution": "Highway Pollution",
        "waterPollution": "Water Pollution",
        "landscapeTransformation": "Landscape Transformation",
        "playgroundHeat": "Playground Heat",
        "shadeEquityAlt": "A Los Angeles resident stands in front of a bus stop.",
        "highwayPollutionAlt": "A Los Angeles resident stands on a pedestrian bridge.",
        "waterPollutionAlt": "A Los Angeles resident holds a fishing pole in front of the LA River.",
        "landscapeTransformationAlt": "A homeowner holds a garden hose in their front yard.",
        "playgroundHeatAlt": "A child is standing at a playground."
    },
    "ConsiderRemedies": {
        "heading": "Consider Remedies",
        "subhead": "Explorable",
        "description": "This interactive shows photos of different site types overlaid with illustrated remedies. It encourages exploration of specific remedies and their effects while offering insights into how they can be combined to mitigate site stressors.",
        "exampleProjects": "Example Projects",
        "emptyState": "Click on an example project to explore remedies and how they work in different project types and settings.",
        "learnMore": "Learn about funding opportunities.",
        "prev": "Prev",
        "firstRemedy": "First Remedy",
        "nextRemedy": "Next Remedy",
        "restart": "Restart",
        "mousePrompt": "Mouse over the scene to discover remedies at work.",
        "useCaseNames": [
            "Residential",
            "Community Garden",
            "Sports Field",
            "School",
            "Park",
            "Stormwater",
            "Resilience Plans",
            "Urban Forestry",
            "Green Streets",
            "Transportation",
            "Community Center"
        ],
        "useCaseDescriptions": [
            "<p>How can residential homes become living infrastructure?</p><p>Explore remedies like permeable pavement, onsite water storage, solar panels, and ecological gardens to learn more about their multi-benefit effects.</p>",
            "<p>Community gardens can help regenerate life, grow neighborhood participation, and increase beauty and resilience.</p><p>Explore remedies like benches, vegetable gardens, and fruit trees to learn more about their multi-benefit effects.</p>",
            "<p>Did you know that sports fields can be great locations for storing and infiltrating water?</p><p>Explore remedies like infiltration basins, exercise equipment, lighting, drinking fountains, and sports areas to learn about their multi-benefit effects.</p>",
            "<p>Schoolyards don’t have to be hot stretches of asphalt.</p><p>Explore how remedies like shade structures, playgrounds, ecological gardens, interpretive signs, and storage tanks can help schoolyards become cooler and healthier places to play.</p>",
            "<p>Access to parks and greenspace is linked to healthier and more resilient communities.</p><p>Explore remedies like lawns, shade trees, outdoor gathering spaces, restrooms, and rain gardens to learn more about their multi-benefit effects.</p>",
            "<p>In the L.A. Basin, much of the stormwater becomes polluted runoff that ends up in the Pacific Ocean.</p><p>Explore remedies like storage ponds, wetlands, and walking paths to learn more about how collecting stormwater can help prevent flooding and downstream water contamination, increase local water resilience, create habitat, and become places for healthy recreation.</p>",
            "<p>Communities that plan for conditions like heat and flooding are better able to mitigate their adverse impacts.</p><p>Explore remedies like cooling and hygiene stations, art, and infiltration tanks to learn how they can help improve public health, increase cooling and access to water, and create a sense of place.</p>",
            "<p>Trees and plants improve cities by cleaning the air, creating habitat, and shading the ground.</p><p>Explore remedies like buffer trees, shade trees, and ecological gardens to learn more about their roles in creating cool, biodiverse spaces that have healthy air quality.</p>",
            "<p>How can streets become living infrastructure?</p><p>Explore remedies like slow streets, shade trees, bike paths, and bioswales to learn more about how streets can increase community health and mobility while providing cooler temperatures and biodiverse habitat.</p>",
            "<p>Increasing pedestrian mobility and public transportation reduces smog and creates healthier communities.</p><p>Explore transit remedies like bus stops and bike paths to learn more about how they can increase the mobility of a city and improve public health and recreation.</p>",
            "<p>Community centers serve as critical hubs for addressing disconnection within communities.</p><p>Explore remedies like community center buildings, splash pads, benches, bike racks, and parking areas to learn more about how they can provide cool spaces to recreate and strengthen community identity and purpose.</p>"
        ]
    },
    "PrimerLibrary": {
        "heading": "Primers",
        "description": "Deepen your knowledge of Living Infrastructure through videos, articles, and interactive content.",
        "backgroundImageAlt": "A single drop of lake water from Magic Johnson Park contains a jamboree of healthy microorganisms that come in many shapes and sizes, including spheres, rods, and spirals.",
        "minutes": "minutes",
        "types": {
            "video": "Video",
            "interactive": "Interactive"
        },
        "primers": {
            "identify-stressors": {
                "title": "Identify Stressors",
                "description": "Watch residents explore the various environmental stressors around the Los Angeles area.",
                "alt": "A Los Angeles resident stands in front of the LA River."
            },
            "think-differently-about-water": {
                "title": "Think Differently about Water",
                "description": "Watch the unexplored potential of what’s possible when adopting a living systems approach to healing the water and land right here in L.A.",
                "alt": "An image of the LA basin shows where rain water runoff dumps out into the ocean from the city."
            },
            "living-infrastructure-invitation": {
                "title": "Living Infrastructure Invitation",
                "description": "Explore the evolving, reciprocal partnership between human activity and the living environment.",
                "alt": "Two people sit at a picnic table in a park underneath a large shaded oak tree. An illustration is overlaid with someone riding a bike. A butterfly floats by with the question, “What does here need?”"
            },
            "living-infrastructure-in-action": {
                "title": "See Living Infrastructure in Action",
                "description": "Engage with how living infrastructure helped a community heal in the aftermath of environmental injustice.",
                "alt": "Magic Johnson Park is overlaid with an illustration of bustling schools of fish, turtles, birds and lush aquatic vegetation. In the background, there is a storm water filtration system."
            },
            "consider-remedies": {
                "title": "Consider Remedies",
                "description": "Interact with various remedy tools that strengthen living systems from environmental stressors.",
                "alt": "A house with a bare driveway is overlaid with an illustration of climate friendly plants and flowers and a rain barrel to collect rainwater from the roof of the house."
            },
            "landscape-transformation": {
                "title": "Landscape Transformation",
                "description": "Learn the benefits and tradeoffs of different landscaping approaches through one yard’s transformation.",
                "alt": "An assortment of remedies such as a native garden, rain catchment, and permeable pavers are illustrated atop a photo of an average home."
            }
        }
    },
    "RemediesAndEffects": {
        "remedies": "Remedies",
        "benefits": "Benefits",
        "cost": "Cost",
        "footprintSize": "This remedy’s benefits can change based on its customizable footprint size. Benefits shown here are based on the default footprint of",
        "sqft": "sqft",
        "remedyCost": "This remedy’s cost can change based on its customizable footprint size. Costs shown here are based on the default footprint of"
    },
    "ReferencesHeader": {
        "remedy": "remedies",
        "effect": "benefits",
        "dataLayer": "data layers",
        "collapseSidebar": "Collapse sidebar",
        "openSidebar": "Open sidebar"
    },
    "RemedySticker": {
        "clickToDrag": "Click to drag onto your site",
        "addToSketch": "Add to Site",
        "add": "Add",
        "added": "Added",
        "clickToAdd": "Click to add to your site"
    },
    "MissingResults": {
        "crystalBallAlt": "An animation of a butterfly flapping its wings inside of a crystal ball pulsing with energy.",
        "missingSearchResults": "We couldn't find any matches.<br/>Try a new search, or let us know what you're looking for.",
        "tellUs": "Tell us what we're missing"
    },
    "EmptyPanel": {
        "createSite": "Create a site",
        "addRemedy": "Add a remedy",
        "saveSiteAddRemedies": "Save your site to add remedies",
        "siteInfoHeader": "Get to know a place",
        "siteInfoText": "Create a site to explore land use, ownership, boundaries, watersheds, and Indigenous territories.",
        "siteInfoAlt": "An illustration of Turtle Island.",
        "dataInsightsHeader": "Discover what makes this place unique",
        "dataInsightsText": "Create a site to learn about a place with data—from heat and water flow to community health and habitat.",
        "dataInsightsAlt": "An illustration of hands holding water.",
        "costsBenefitsHeader": "See the effects of your design",
        "costsBenefitsProjectText": "Once you start adding remedies, you can see the estimated costs and benefits of your project. Experiment by combining remedies; track how benefits change and grow.",
        "costsBenefitsAllSitesText": "Once you start adding remedies, you can see the estimated costs and benefits of your sites. Experiment by combining remedies; track how benefits change and grow.",
        "costsBenefitsSiteText": "Once you start adding remedies, you can see the estimated costs and benefits of your site. Experiment by combining remedies; track how benefits change and grow.",
        "costsBenefitsViewerHeader": "No costs and benefits yet",
        "costsBenefitsViewerText": "Costs and benefits from your team's design work will appear here as remedies are added.",
        "costsBenefitsAlt": "An illustration of someone sketching a design.",
        "communityVoiceHeader": "Capture Community Voice",
        "communityVoiceDescription": "Comment with community input, local knowledge, or information about site conditions. Keep the conversation going with replies.",
        "commentsHeader": "No comments yet",
        "commentsDescription": "Comments from other project members will appear here when they're added.",
        "addComment": "Add a comment",
        "saveSiteComments": "Save your site to leave comments",
        "commentsAlt": "An illustration of two people standing on a green landscape, pointing and discussing plans for the site.",
        "createStory": "Create a story",
        "storiesHeader": "Share a story of this place",
        "storiesText": "",
        "storiesViewerText": "",
        "storiesAlt": "An illustration of a large shady oak tree with people resting beneath it."
    },
    "TipsResourcesTab": {
        "tips": "Tips",
        "resources": "Resources"
    },
    "EmptyTab": {
        "nothingHere": "There is nothing here. Have a question?",
        "getAdvice": "Get Advice",
        "altText": "A flock of multicolored birds flapping their wings."
    },
    "RemediesPanel": {
        "remedies": "Remedies",
        "closePanel": "Close remedies panel",
        "search": "Search for a remedy...",
        "searchDescription": "Results update automatically as you type.",
        "filterTooltip": "Filter",
        "filter": "Filter remedies",
        "clearSearch": "Clear search",
        "remove": "Remove",
        "learnMore": "Learn more about",
        "filtering": "Filter"
    },
    "UILayerItem": {
        "learnMore": "Learn more about",
        "selectLayer": "Select layer",
        "deselectLayer": "Deselect layer",
        "expandPack": "Expand pack",
        "collapsePack": "Collapse pack",
        "withLayers": "with %n layers",
        "withSelectedLayers": "with %numerator selected out of %denominator layers",
        "selectAllLayers": "Select all layers in the pack",
        "selectAll": "Select all",
        "deselectAll": "Deselect all",
        "packs": "Packs:",
        "pack": "Pack:",
        "counterText": "%numerator selected out of %denominator layers"
    },
    "FiltersDropdown": {
        "heading": "Filter Remedies",
        "exit": "Close Filters",
        "benefits": "Benefits"
    },
    "DataLayerSpecs": {
        "lastUpdated": "Last Updated",
        "relatedEffects": "Related Benefits:",
        "packs": "Packs:",
        "pack": "Pack:"
    },
    "DataLayerDocumentation": {
        "ranges": "Ranges",
        "categories": "Categories",
        "methodology": "Methodology"
    },
    "DataSources": {
        "dataSources": "Data Sources",
        "lastUpdated": "Last Updated"
    },
    "LeftPanel": {
        "siteInfo": "Site Information",
        "dataInsights": "Data Insights",
        "costsBenefits": "Costs & Benefits",
        "comments": "Comments",
        "site": "Site",
        "siteTooLarge": "Some information is currently unavailable for sites larger than ~100M sqft.",
        "invalidPolygon": "Your site cannot have intersecting edges. Consider editing your site.",
        "apiError": "Your site profile cannot be loaded at the moment.",
        "selectSite": "Select this site?",
        "stories": "Stories"
    },
    "SitesListPanel": {
        "siteInfoInstructions": "Choose a site to see the corresponding information.",
        "dataInsightsInstructions": "Choose a site to see the corresponding data."
    },
    "SiteTitleCard": {
        "noDescription": "No description yet."
    },
    "SiteRowInner": {
        "creator": "Creator",
        "editSiteDetails": "Edit site details",
        "showMore": "Show more",
        "showLess": "Show less"
    },
    "SketchPanel": {
        "selectASite": "Select a site",
        "drawSite": "Draw a Site",
        "zoomOrSearch": "Zoom and tap on a parcel to create a site or ",
        "drawYourSite": "draw your own"
    },
    "UIStarIcon": {
        "pin": "Pin"
    },
    "LayerPackTab": {
        "layersInPack": "Layers in this pack"
    },
    "ToggleLayerButton": {
        "useDataLayer": "Use Data Layer",
        "useLayerPack": "Use Layer Pack",
        "dataLayerOn": "Data Layer On",
        "layerPackOn": "Layer Pack On"
    },
    "OpportunitiesSection": {
        "opportunities": "Opportunities",
        "showAll": "Show all",
        "showLess": "Show less",
        "opportunitiesTooltip": "Opportunities are based on available data and relative to LA County. A high level indicates improvements may be needed. This data should be supplemented with community input and site studies.",
        "Very High": "Very High Opportunities",
        "High": "High Opportunities",
        "Moderate": "Moderate Opportunities",
        "Low": "Low Opportunities",
        "Very Low": "Very Low Opportunities",
        "Unknown": "No Data Available",
        "pin": "Pin"
    },
    "DataInsightsPanel": {
        "land": "Land",
        "yes": "Yes",
        "no": "No",
        "programs": "Programs"
    },
    "PrimerHeader": {
        "home": "Home",
        "learn": "Learn"
    },
    "UIPersistentPanel": {
        "options": "Options",
        "expand": "Expand",
        "collapse": "Collapse",
        "expandSketchPanel": "Expand site panel",
        "collapseSketchPanel": "Collapse site panel"
    },
    "MapSubtools": {
        "editShape": "Edit shape",
        "duplicate": "Duplicate",
        "delete": "Delete",
        "click": "Click",
        "draw": "Draw",
        "parcelSelectDisabled": "Clicking to select land is unavailable outside LA county"
    },
    "SiteDeleteConfirmation": {
        "confirmDeleteHeading": "Are you sure you want to delete this site?",
        "confirmDelete": "Once you delete this Site, you and everyone in this project will not be able to access it."
    },
    "OnboardingPanelButtons": {
        "cancel": "Cancel",
        "selectSite": "Select site",
        "saveAndSignup": "Save and sign up"
    },
    "ParticipantLinkBanner": {
        "shareWarning": "We've updated our sharing links, and this link is no longer supported for anyone you shared it with. <a href=\"https://help.la.livinginfrastructure.org/en/articles/9930995-sharing\" target=\"_blank\">Here is an article</a> that outlines how to invite collaborators.",
        "needAccess": "To access this project, please reach out to the person who shared it and ask them to invite your email address. <a href=\"https://help.la.livinginfrastructure.org/en/articles/9930995-sharing\" target=\"_blank\">Here is an article</a> that outlines how to invite collaborators."
    },
    "PublicLinkBanner": {
        "contributeOnlyMessage": "You are now contributing to this project. To create your own project, sign up for a free account.",
        "contributeOnlyMessageAuthenticated": "You are now contributing to this project.",
        "viewOnlyMessage": "You are only able view this project. To create your own project, sign up for a free account.",
        "viewOnlyMessageAuthenticated": "You are only able view this project.",
        "closeButton": "Close",
        "signupButton": "Sign up"
    },
    "ContributorModal": {
        "headerText": "Join project",
        "formSubHeaderText": "Adding your name is optional and will be visible to anyone who views this project.",
        "joinDisclaimer": "By clicking “Begin”, you agree to our <a class=\"underline\" href=\"https://livinginfrastructure.org/terms\">Terms of Service</a> and <a class=\"underline\" href=\"https://livinginfrastructure.org/privacy\">Privacy Policy</a>",
        "firstNameLabel": "First Name",
        "lastNameLabel": "Last Name",
        "firstNamePlaceholder": "Enter first name",
        "lastNamePlaceholder": "Enter last name",
        "submitButtonText": "Begin",
        "errorText": "Something went wrong, please try again"
    },
    "RequestNewLink": {
        "requestNewLink": "Request a new link",
        "subheader": "<p>Welcome back to the updated Field Kit!</p><p>We've updated our sharing links, and this link is no longer supported. To access this project, please reach out to the person who shared it and ask them to invite your email address.</p><p><a href=\"https://help.la.livinginfrastructure.org/en/articles/9930995-sharing\" target=\"_blank\">Here is an article</a> that outlines how to invite collaborators.</p>",
        "gifAltText": "To access this project, please reach out to the person who shared it and ask them to invite your email address."
    },
    "UITabs": {
        "benefitsCosts": "Benefits & Costs",
        "pairings": "Pairings",
        "tipsResources": "Tips & Resources",
        "remedies": "Remedies",
        "dataLayers": "Data Layers",
        "documentation": "Documentation",
        "tips": "Tips",
        "benefits": "Benefits",
        "conditions": "Conditions",
        "details": "Details",
        "sites": "Sites",
        "layers": "Layers",
        "summary": "Summary"
    },
    "CollaborateBanner": {
        "toJoin": "To join",
        "please": "please",
        "signup": "sign up",
        "login": "log in"
    },
    "BrowserError": {
        "checkBrowserSettings": "Check your browser settings",
        "subheader": "The Living Infrastructure Field Kit map is experiencing issues. To access this project, you may need to check your browser settings. <a href=\"https://help.la.livinginfrastructure.org/en/articles/10487073-troubleshooting-your-browser-settings\">Learn more</a>",
        "altText": "An illustration of a shorebird wading through shallow water, with ripples forming around its feet."
    },
    "GuidebookWelcome": {
        "heroAlt": "An illustration of wildlife such as a bird, a butterfly, and a frog emerging from a blooming flower.",
        "welcomeHeading": "Welcome to the guidebook",
        "welcomeText": "The guidebook is your living infrastructure knowledge hub and project companion—just look for the book icon to unlock tips, insights, and inspiration as you go. Inside, you’ll find helpful articles for every remedy, benefit, and data layer in the Field Kit.",
        "welcomeCTA": "Ready to dive in?",
        "remediesHeading": "Remedies",
        "remediesAlt": "Sticker-like icons of trees, a shade structure, and a playground on a map, plus a benefits graph.",
        "remediesText": "The Field Kit contains a library of over 40 living infrastructure remedies like rain garden, storage tank, and shade structure, each with its own dedicated guidebook article. Browse the library to learn more.",
        "benefitsHeading": "Benefits",
        "benefitsAlt": "Sticker-like icons of benefits such as trees and a playground overlaid on a site location map.",
        "benefitsText": "Adding remedies to your site brings up an overview of their estimated costs and benefits. Click on the guidebook to go deeper into remedy benefits like cooling, public health, and water supply.",
        "dataLayersHeading": "Data Layers",
        "dataLayersAlt": "A flood risk map of the city of Alhambra with a graph showing risk levels from 0 to over 5.",
        "dataLayersText": "Use the guidebook to learn more about the methodology and data sources behind some of L.A. County's most detailed datasets. Each article includes relevant tips to guide your project and help you make the most of the data."
    },
    "NoDataHere": {
        "noDataAlt": "An illustration of an elephant gazing at a a tar pit with LACMA's 'Urban Light' in the background.",
        "noDataMessage": "This data is only available for sites within L.A. County. Take a look at a <a href=\"https://la.livinginfrastructure.org/workshops/7a335a32-33a0-4b01-99ca-b26cee0c3fa8/sketches/028facd1-923d-41cf-aee1-0ec4e9de6ceb\" target=\"_blank\" style=\"text-decoration: underline;\">sample site</a> to see a complete site profile."
    },
    "ProjectOptionsDropdown": {
        "options": "Options",
        "rename": "Rename",
        "share": "Share",
        "duplicate": "Duplicate",
        "projectDeleted": "Project deleted.",
        "delete": "Delete",
        "confirmDeleteHeading": "Are you sure you want to delete this project?",
        "confirmDelete": "Once you delete a project, you and everyone in this project will not be able to access it."
    },
    "StormwaterSettingsDropdown": {
        "settings": "Rainfall Data Settings",
        "timespan": "Timespan",
        "yearlyAverage": "Yearly average",
        "stormEvent": "Storm event",
        "units": "Units",
        "gallon": "Gallon",
        "gallons": "Gallons",
        "acreFoot": "Acre-foot",
        "acreFeet": "Acre-feet",
        "people": "People",
        "personYear": "person-year",
        "personYears": "person-years",
        "yearlyAverageDescription": "yearly average",
        "stormEventDescription": "85th percentile storm",
        "close": "Close"
    },
    "UIRadioButton": {
        "selected": "Selected radio button",
        "unselected": "Unselected radio button"
    },
    "InvalidVersionModal": {
        "reloadRequired": "Reload Required",
        "modalBody": "A new version of the Living Infrastructure Field Kit is available. Reload to access your project and",
        "latestFeaturesLink": "the latest features",
        "reload": "Reload"
    },
    "useAddSite": {
        "defaultSiteNamePrefix": "Site",
        "siteSuccess": "Site successfully created",
        "duplicateError": "An error occurred while duplicating your site.",
        "duplicateSuccess": "Site duplicated successfully."
    },
    "SettingsSidebar": {
        "settings": "Settings",
        "communicationPreferences": "Communication preferences",
        "userProfile": "Profile"
    },
    "CommunicationPreferences": {
        "communicationPreferences": "Communication preferences",
        "emailPreferencesSaved": "Email preferences updated.",
        "toolAnalyticsSaved": "Tool analytics updated.",
        "saveError": "Couldn't update your preferences. Please try again.",
        "profile": "Profile",
        "emailUpdates": "Email updates",
        "toggleEmailUpdates": "Toggle email updates",
        "emailUpdatesInfo": "Subscribe to our newsletter for exclusive insights into living infrastructure, tips, and the latest developments in Living Infrastructure Field Kit.",
        "toggleTracking": "Toggle tracking",
        "privacyPolicy": "Privacy Policy",
        "toolAnalytics": "Tool analytics",
        "trackingToolInfo": "In-product tracking helps identify which features are most popular and where issues occur, allowing us to refine to better meet the needs of our communities. Learn about our data practices on our"
    },
    "UserProfile": {
        "profile": "Profile",
        "firstNameLabel": "First name",
        "lastNameLabel": "Last name",
        "emailLabel": "Email",
        "organizationLabel": "Organization",
        "avatarColorLabel": "Avatar color",
        "firstNamePlaceholder": "Enter first name",
        "lastNamePlaceholder": "Enter last name",
        "organizationPlaceholder": "Enter organization",
        "firstNameError": "Please enter your first name",
        "lastNameError": "Please enter your last name",
        "emailError": "Please enter a valid email address",
        "organizationError": "Please enter your organization",
        "errorMessage": "Error signing up",
        "errorAccountExists": "An account with this email already exists",
        "passwordLabel": "Password",
        "editPassword": "Edit password",
        "deleteAccount": "Delete account",
        "updated": "updated",
        "saveError": "An error occured while saving",
        "deleteConfirmTitle": "Are you sure you want to delete your account?",
        "deleteConfirmText": "Once you delete your account, you will lose the ability to access the Field Kit and all your projects.",
        "deleteError": "An error occurred while deleting your account.",
        "emailInUseError": "This email is already in use.",
        "editAvatarColorLabel": "Edit avatar color"
    },
    "EditPasswordModal": {
        "editPassword": "Edit password",
        "currentPassword": "Current password",
        "newPassword": "New password",
        "passwordsMustMatch": "Passwords must match.",
        "forgotPassword": "Forgot password?",
        "save": "Save",
        "passwordUpdated": "Password updated.",
        "passwordError": "An error occurred while updating your password.",
        "currentPasswordError": "Incorrect current password."
    },
    "DuplicateWorkshopModal": {
        "title": "Duplicate project",
        "description": "What would you like to duplicate?",
        "duplicateNameError": "A site already exists with this title. Please try a different title.",
        "updateSketchError": "Your site cannot be updated at the moment. We suggest resetting your internet connection or finding a faster one. If that doesn’t work, bear with us as we resolve the issue on our end. Thank you for your patience!",
        "sketchDuplicated": "Project duplicated.",
        "confirmCloseHeading": "Are you sure you want to discard these Duplication Options?",
        "confirmClose": "Once you discard these Duplication Options, you will not be able to access them again.",
        "siteNameLabel": "Site(s)",
        "remediesNameLabel": "Remedies",
        "duplicateSubmitButton": "Duplicate"
    },
    "ZoomToViewButton": {
        "zoomToViewData": "Zoom to view data"
    },
    "UIDropdownItems": {
        "dropdownItems": "Dropdown options"
    },
    "SphericalAdmin": {
        "sortBy": "Sort by",
        "search": "Search people",
        "searchPlaceholder": "Search by name, email, organization, or ID",
        "clearSearch": "Clear search",
        "noMatches": "No people match your search"
    },
    "UIPanelCard": {
        "pin": "Pin",
        "add": "Add",
        "toMap": "to map"
    },
    "PairingCard": {
        "pairing": "Pairing"
    },
    "NavigationSidebar": {
        "collapse": "Collapse menu",
        "expand": "Expand menu",
        "siteInfo": "Site Information",
        "dataInsights": "Data Insights",
        "costBenefits": "Costs & Benefits",
        "comments": "Comments",
        "unreadComments": "Unread comments",
        "stories": "Stories"
    },
    "CommentsPanel": {
        "comments": "Comments",
        "noFilterResults": "No comments match these filters.",
        "markAllAsReadError": "Some comments couldn't be marked as read. Please try again."
    },
    "CommentsToolbar": {
        "sort": "Sort",
        "sortBy": "Sort by",
        "newestFirst": "Newest first",
        "oldestFirst": "Oldest first",
        "unreadFirst": "Unread first",
        "filter": "Filter",
        "filterComments": "Filter comments",
        "filterByPerson": "Filter by person",
        "categories": "Categories",
        "categorized": "Categorized",
        "uncategorized": "Uncategorized",
        "bothCategories": "Both",
        "people": "People",
        "noPeople": "No one has commented yet.",
        "hideAllComments": "Hide all comments",
        "showAllComments": "Show all comments"
    },
    "CommentsActiveFilters": {
        "removeFilter": "Remove filter"
    },
    "UIHeader": {
        "back": "Back",
        "backToProject": "Back to project",
        "backToHome": "Back to home"
    },
    "UIPaginationDots": {
        "label": "Pages",
        "page": "Page"
    },
    "MarkAllAsReadButton": {
        "markAllAsRead": "Mark all as read",
        "markAllAsReadUnavailable": "Mark all as read (unavailable because all comments are already read)"
    },
    "CommentCard": {
        "unread": "Unread",
        "replyCount": "1 reply",
        "repliesCount": "{count} replies",
        "anonymous": "ANONYMOUS"
    },
    "CommentsExport": {
        "comments": "Comments",
        "footerTextComments": "These comments were collected using the Living Infrastructure Field Kit.",
        "projectName": "Project Name",
        "thread": "Thread",
        "replyLevel": "Reply level",
        "comment": "Comment",
        "submitter": "Submitter",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "datetimeSubmitted": "Datetime Submitted (UTC)",
        "anonymous": "Anonymous"
    },
    "StoriesPanel": {
        "createStory": "Create a story",
        "playStory": "Play story",
        "editStory": "Edit story",
        "deleteStory": "Delete story",
        "oneScene": "1 scene",
        "manyScenes": "{count} scenes",
        "confirmDeleteHeading": "Delete Story",
        "confirmDelete": "Are you sure you want to delete this story? This action cannot be undone.",
        "copyLink": "Copy link",
        "duplicateStory": "Duplicate story",
        "actionFailed": "Something went wrong. Please try again.",
        "linkCopied": "Story link copied",
        "copyOfStory": "Copy of {name}",
        "beta": "Beta",
        "betaMessage": "This is a limited release feature. If you need support or have feedback about your experience,",
        "betaFeedbackLink": "get in touch with us"
    },
    "StoryEditorBanner": {
        "confirmDeleteSceneHeading": "Delete Scene",
        "confirmDeleteScene": "Are you sure you want to delete \"{sceneTitle}\"?",
        "saveFailed": "Your story could not be saved. Please try again."
    }
}
